import { render } from "./CockpitHeader.vue?vue&type=template&id=885d1788&scoped=true"
import script from "./CockpitHeader.vue?vue&type=script&lang=js"
export * from "./CockpitHeader.vue?vue&type=script&lang=js"

import "./CockpitHeader.vue?vue&type=style&index=0&id=885d1788&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885d1788"]])

export default __exports__